// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutDefault_wrapper__2mplZ","footerDiv":"LayoutDefault_footerDiv__2V8jp","CommonContainer":"LayoutDefault_CommonContainer__HidqJ"};